<template>
	<div class="wrapBox">
		<navheader current="2"></navheader>
		<div class="bannerBox">
			<!-- <div class="bannerTextBox">
				<div>
					<span v-for="(item,index) in list"  :key="index" :class="{active:cur==index}" @click="changeList(index)">{{item}}</span>
				</div> -->
			<!-- </div> -->
			<div class="smallNav">
				<span v-for="(item,index) in smallNavList"  :key="index" :class="{active:curSmall==index}" @click="changeDepart(index)">{{item.deptName}}</span>
			</div>
		</div>
		<div class="box1">
			<!-- ../assets/images/ExpertTeambg.png -->
			<img :src="departInfo.photoImg" alt="" class="departImg">
			<div class="textBox">
				<div class="textTitle">
					<i></i><span>{{departInfo.deptIntroduction}}</span>
				</div>
				<div class="textctx" v-html="departInfo.memoPub"></div>
			</div>
		</div>
		<div class="box2">
			<div class="ctx">
				<div class="textTitle">
					<span>医疗服务</span>
				</div>
				<div   class="textctx" v-html="departInfo.memoScope"></div>
			</div>
		</div>
		<footercommon></footercommon>
	</div>
	
</template>

<script>
	import navheader from "../components/navheader.vue";
	import footercommon from "../components/footercommon.vue";
	import {GetDepart} from '@/api/api'
	export default{
		components: { navheader,footercommon},
		data(){
			return{
				list:["科室介绍","专家介绍"],
				cur:0,
				smallNavList:[],
				curSmall:0,
				departInfo:{},
			}
		},
		mounted() {
			this.query()
		},
		methods: {
			changeList(index){
				this.cur=index
			},
			query(){
				GetDepart({status:1}).then(res => {
					this.smallNavList=res.data.data.rows
					this.getDetail(this.smallNavList[this.curSmall].guid)
				})
			},
			getDetail(guid){//获取详细内容
				GetDepart({guid: guid,status: 1}).then(res => {
					this.departInfo=res.data.data.rows[0]
				})
			},
			changeDepart(index){
				this.curSmall=index
				this.getDetail(this.smallNavList[this.curSmall].guid)
			}
		},
	}
</script>

<style lang="scss" scoped>
	.bannerBox{
		background-image: url('../assets/images/ExpertTeambanner1.png');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		height: 22.875rem;
		box-sizing: border-box;
		overflow: hidden;
		.bannerTextBox{
			padding: 11.25rem 0 0 3.4375rem;
			min-width: $commoneWidth;
			margin: 0 auto;
			div{
				cursor: pointer;
				width: 30rem;
				height: 7.5rem;
				background-color: #fff;
				font-size: 2rem;
				padding: 1.25rem;
				box-sizing: border-box;
				white-space: nowrap; /* 防止换行 */
				border-radius: 0px 1.4375rem 1.4375rem 1.4375rem;
				box-shadow: 0px 0.25rem 2.2625rem 0px rgba(12, 90, 85, 0.14);
				span{
					display: inline-block;
					width: 11.875rem;
					line-height: 5rem;
					text-align: center;
					color:$baseColor;
					margin-right: 2.5rem;
					&.active{
						background-color: $baseColor;
						color:#fff;
						border-radius: 0px 1.375rem 1.375rem 1.375rem;
					}
				}
			}
		}
		.smallNav{
			cursor: pointer;
			margin: 21rem 3.4375rem 0 3.4375rem;
			background-color: #fff;
			padding: 0.75rem 2rem;
			box-shadow: 0px 0.25rem 2.2625rem 0px rgba(12, 90, 85, 0.14);
			border-radius: 0.5rem;
			white-space: nowrap; /* 防止换行 */
			display: flex;
			justify-content: space-between;
			position: absolute;
			z-index: 9999;
			width: 90%;
			span{
				display: inline-block;
				width: 8.125rem;
				line-height: 2.875rem;
				color:$fintColor;  
				font-size: 1.375rem;
				text-align: center;
				&.active{
					background: rgba(16, 197, 186, 0.11);
					color: $baseColor;
				}
			}
		}
	}
	.box1{
		min-width: $commoneWidth;
		margin: 0 auto;
		padding:7.5rem 7.5rem 2.5rem 7.5rem;
		display: flex;
		.departImg{
			width: 24.6875rem;
			height: 27.1875rem;
			border-radius: 3.125rem;
		}
		.textBox{
			margin-left: 2.75rem;
			margin-top: 1.375rem;
			width: 100%;
		}
		
	}
	.box2{
		// min-width: $commoneWidth;
		width: 100%;
		margin: 0 auto;
		.ctx{
			margin: 2.5rem auto;
			background-color: $bgcolor;
			border-radius: 2.125rem;
			padding: 2.375rem 5.25rem 8.75rem 5.25rem;
			max-width: 80%;
			.textTitle{
				display: flex;
				justify-content: center;
			}
			.subtext{
				margin-left: 2.75rem;
			}
		}
	}
	::v-deep .ql-indent-1{
		margin:0 ;
		margin-left:2.75rem;
	}  
	@media screen and (max-width: 768px) {//手机版本
		.bannerBox{
			background-size: 100%;
			height: 127px;
			.bannerTextBox{
				padding: 40px 0 0 20px;
				width: 100%;
				min-width: auto;
				max-width: 768px;
				div{
					width: 210px;
					height: 60px;
					font-size: 16px;
					padding: 10px;
					border-radius: 0px 13px 13px 13px;
					span{
						width: 90px;
						line-height: 40px;
						margin-right: 10px;
						&.active{
							border-radius: 0px 12px 12px 12px;
						}
					}
				}
			}
			.smallNav{
				margin: 90px 20px 0 20px;
				padding:6px;
				white-space: nowrap; /* 防止换行 */
				flex-wrap: wrap;
				justify-content: flex-start;
				span{
					display: inline-block;
					width: 20%;
					line-height: 26px;
					font-size: 12px;
				}
			}
		}
		.box1{
			min-width: auto;
			max-width: 768px;
			margin: 0 auto;
			padding:20px;
			padding-top: 60px;
			display: flex;
			flex-direction: column;
			.departImg{
				width: 336px;
				height: 370px;
				border-radius: 20px;
				margin-bottom: 10px;
			}
			.textBox{
				margin: 0;
			}
			
		}
		.box2{
			width:100%;
			min-width: auto;
			max-width: 768px;
			.ctx{
				margin:20px;
				border-radius: 24px;
				padding:10px;
				.textTitle{
					display: flex;
					justify-content: center;
				}
				.subtext{
					margin-left: 44px;
				}
			}
		}
		::v-deep .ql-indent-1{
			margin:0 ;
			margin-left:24px;
		}  
	}
	.carousel-img-container {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		overflow: hidden;
		background-color: #000;
	}

	.carousel-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center;
	}
</style>